module.exports = __webpack_public_path__ + "media/images/frontend/lamberet/bef-af-c893887e98aaadb710d4147036ed9284.png";